<template>
  <div class="page-wrapper" style="padding-top: 0">

    <h3>基本信息</h3>
    <div class="item">
      <div class="flex">
        <span>业主名称：</span>
        <span class="bold">{{data.ownerName}}</span>
      </div>
    </div>
    <div class="item ">
      <span>业主类型：</span>
      <span class="bold">{{data.ownerType==1?'企业':'个人'}}</span>
    </div>

    <!--<div v-if="data.ownerType==1">-->
    <div class="item" v-if="data.ownerType==1">
      <span>组织机构代码：</span>
      <a href="javascript:;" v-if="!data.isShow1" @click="show('isShow1')">查看</a>
      <span v-else class="bold">{{data.ownerBusinessCode}}</span>
    </div>
    <div class="item" v-if="data.ownerType==1">
      <span>法定代表人：</span>
      <span class="bold">{{data.ownerLegalRepresent}}</span>
    </div>
    <div class="item" v-if="data.ownerType==1">
      <span>法人身份证号：</span>
      <a href="javascript:;" v-if="!data.isShow2" @click="show('isShow2')">查看</a>
      <span class="bold" v-else>{{data.ownerOperatorIdcard}}</span>
    </div>
    <!--</div>-->

    <!--<div v-if="data.ownerType==2">-->
    <div class="item" v-if="data.ownerType==2">
      <span>业主身份证号：</span>
      <a href="javascript:;" v-if="!data.isShow3" @click="show('isShow3')">查看</a>
      <span class="bold" v-else>{{data.ownerIdcard}}</span>
    </div>
    <div class="item" v-if="data.ownerType==2">
      <span>产权人：</span>
      <span class="bold">{{data.propertyers && data.propertyers[0].propertyer}}</span>
    </div>

    <div class="item" v-if="data.ownerType==2">
      <span>产权人身份证号：</span>
      <a href="javascript:;" v-if="!data.isShow4" @click="show('isShow4')">查看</a>
      <span v-else class="bold">{{ data.propertyers&&data.propertyers[0].propertyerIdcard}}</span>
    </div>

    <!--</div>-->


    <div class="item">
      <span>业主联系人：</span>
      <span class="bold">{{data.ownerUser}}</span>
    </div>


    <div class="item">
      <span>业主联系电话：</span>
      <a href="javascript:;" v-if="!data.isShow5" @click="show('isShow5')">查看</a>
      <span class="bold" v-else>{{data.ownerPhone}}</span>
    </div>

    <div class="item">
      <span>财务联系人：</span>
      <span class="bold">{{data.financeUser}}</span>
    </div>

    <div class="item">
      <span>财务联系电话：</span>
      <a href="javascript:;" v-if="!data.isShow6" @click="show('isShow6')">查看</a>
      <span class="bold" v-else>{{data.financePhone}}</span>

    </div>
    <div class="item">
      <div class="flex">
        <div class="inlineblock">收楼合同号：</div>
        <!--<span>{{data.ownerHouseContract}}</span>-->
        <div class="inlineblock bold" style="max-width: 500px">{{data.ownerHouseContract}}</div>
      </div>
    </div>

    <div class="item">
      <span>开户银行：</span>
      <span class="bold">{{data.ownerBankName}}</span>
    </div>

    <div class="item">
      <span>银行账号：</span>
      <a href="javascript:;" v-if="!data.isShow7" @click="show('isShow7')">查看</a>
      <span v-else class="bold">{{data.ownerBankCard}}</span>
    </div>

    <div class="item">
      <span>经办人：</span>
      <span class="bold">{{data.ownerOperatorName}}</span>
    </div>

    <h3>附件</h3>

    <div class="item">
      <span class="vt">组织机构代码附件：</span>
      <template v-for="item in  data.attachmentBusinessUrl">
        <img v-if="checkImgByUrl(item.attachmentImgUrl)" class="file-img" :src="item.attachmentImgUrl"
             @click.stop="showImg(item.attachmentImgUrl)" alt="">
        <a v-else :href="item.attachmentImgUrl"><img class="file-img" :src="defaultImg" alt=""></a>
      </template>
    </div>
    <div class="item">
      <span class="vt">产权证附件：</span>

      <template v-for="item in  data.propertyImageUrl">
        <img v-if="checkImgByUrl(item.attachmentImgUrl)" class="file-img" :src="item.attachmentImgUrl"
             @click.stop="showImg(item.attachmentImgUrl)" alt="">
        <a v-else :href="item.attachmentImgUrl"><img class="file-img" :src="defaultImg" alt=""></a>
      </template>
    </div>

    <div class="item">
      <span class="vt">其他附件：</span>
      <template v-for="item in  data.otherAttachments">
        <img v-if="checkImgByUrl(item.attachmentImgUrl)" class="file-img" :src="item.attachmentImgUrl"
             @click.stop="showImg(item.attachmentImgUrl)" alt="">
        <a v-else :href="item.attachmentImgUrl"><img class="file-img" :src="defaultImg" alt=""></a>
      </template>
    </div>
    <br>

    <div class=" ">
      <span>备注：</span>
      <span class="bold">{{data.remark}}</span>
    </div>
  </div>
</template>

<script>
  import {getOwnerInfo} from "../../../../../api/owner";
  import {checkImgByUrl} from "../../../../../utils/public";
  import filedefault from '../../../../../assets/filedefault.jpg';

  export default {
    name: "OwnerInfo",
    props: {
      projectFid: {
        type: String,
        default: null
      },
      ownerId: {
        type: String,
        default: null
      }

    },
    watch: {
      ownerId() {
        this.getOwnerInfo()
      }

    },
    data() {
      return {
        defaultImg: filedefault,
        data: {}
      }

    },
    computed: {
      // propertyersShow(){
      //   if(this.data.propertyers&&this.data.propertyers.length>0){
      //     let ret=[]
      //     this.data.propertyers.forEach(ele=>{
      //       ret.push(ele.propertyer)
      //     })
      //     return ret.join(',')
      //
      //   }
      //   else {
      //     return ''
      //   }
      //
      // }

    },
    methods: {
      showImg(src) {
        this.$emit('showimg', src)
      },
      show(key) {
        this.data[key] = true
      },
      checkImgByUrl: checkImgByUrl,
      getOwnerInfo() {
        if (!this.ownerId) {
          return

        }
        var params = {
          ownerId: this.ownerId
        }
        getOwnerInfo(params).then(res => {
          res.data['isShow1'] = false
          res.data['isShow2'] = false
          res.data['isShow3'] = false
          res.data['isShow4'] = false
          res.data['isShow5'] = false
          res.data['isShow6'] = false
          res.data['isShow7'] = false
          this.data = res.data
        })

      }
    },
    created() {
      this.getOwnerInfo()
    }
  }
</script>

<style scoped>
  .item {
    display: inline-block;
    /*margin-right: 30px;*/
    line-height: 1;
    margin-bottom: 25px;
    width: 30%;
    box-sizing: border-box;
    vertical-align: top;
    margin-right: 10px;
    min-width: 150px;
    /*min-width: 100px;*/

  }

  .file-img {
    width: 200px;
    height: 130px;
    overflow: hidden;
    display: inline-block;
    /*margin-bottom: 20px;*/
  }

  .vt {
    vertical-align: top;
  }

  h3 {
    margin: 10px 0 25px 0;
    font-size: 12px;
  }

  .m10 {
    margin: 10px 0 0 0;
  }

  .inlineblock {
    display: inline-block;
    /*margin-right: 20px;*/
    vertical-align: top;
  }

  .bold {
    font-weight: bold;
    min-width: 50px;
    display: inline-block;
  }
  .flex{
    display: flex;
  }


</style>
